import type { Category } from "@/services/collection/categories";
import { CategoryId } from "@/services/collection/categories";
import { splitStringBalanced } from "@/utilities";
import type { MaybeRef } from "vue";
import { unref } from "vue";
import { useGettext } from "vue3-gettext";

type ImageSet = {
  png: string;
  webp: string;
  avif: string;
};

const CategoryId2miniCoverMap: Partial<Record<CategoryId, ImageSet>> = {
  [CategoryId.SportsCards]: {
    png: "/images/categories/minicover/sport-cards.png",
    webp: "/images/categories/minicover/sport-cards.webp",
    avif: "/images/categories/minicover/sport-cards.avif",
  },
  [CategoryId.LegoSets]: {
    png: "/images/categories/minicover/lego-sets.png",
    webp: "/images/categories/minicover/lego-sets.webp",
    avif: "/images/categories/minicover/lego-sets.avif",
  },
  [CategoryId.LegoMinifigures]: {
    png: "/images/categories/minicover/lego-minifigs.png",
    webp: "/images/categories/minicover/lego-minifigs.webp",
    avif: "/images/categories/minicover/lego-minifigs.avif",
  },
  [CategoryId.Pokemon]: {
    png: "/images/categories/minicover/pokemon.png",
    webp: "/images/categories/minicover/pokemon.webp",
    avif: "/images/categories/minicover/pokemon.avif",
  },
};

export function useCategory(category: MaybeRef<Category | undefined>) {
  const { $gettext } = useGettext();

  const miniCover = computed(() => {
    const c = unref(category);
    if (c === undefined) {
      return undefined; // Category not loaded yet
    } else {
      const img = CategoryId2miniCoverMap[c.id];
      if (img === undefined) {
        throw new Error("Requested medium cover image for category #" + c.id + ". However image is not defined.");
      } else {
        return img;
      }
    }
  });

  const nameDividedIntoTwoParts = computed(() => {
    const name = normalizedName.value;
    if (name === undefined) {
      return undefined; // Category not loaded yet
    } else {
      return splitStringBalanced(name);
    }
  });

  // Yes, we modify name for this category, .... ugh
  const normalizedName = computed(() => {
    const c = unref(category);
    if (c === undefined) {
      return undefined; // Category not loaded yet
    } else {
      let name = c.name;
      if (c.id === CategoryId.Pokemon) {
        name += " " + $gettext("karty");
      }
      return name;
    }
  });

  return {
    miniCover,

    nameDividedIntoTwoParts,
  };
}
